/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import PrimaryButtonQuestion from "../../components/button/primary-button/PrimaryButtonQuestion";
import SecondaryButtonQuestion from "../../components/button/secondary-button/SecondaryButtonQuestion";
import TertiaryButtonQuestion from "../../components/button/tertiary-button/TertiaryButtonQuestion";
import BackgroundImageFromUrl from "../../components/parseImage/BackgroundImageFromUrl";
import ImageFromUrl from "../../components/parseImage/ImageFromUrl";
import TagCheckMultipleResponse from "../../components/question/TagCheckMultipleResponse";
import ConstantStrings from "../../constants/ConstantStrings";
import { checkImage } from "../../constants/checkImage";
import QuestionNumberTag from "../../detail-components/QuestionNumberTag";
import ScrollRef from "../../detail-components/ScrollRef";
import {
  setQuestionState,
  setQuestionVisible,
} from "../../reducers/questionsSlice";
import "../../styling/layout-components/MultipleScroll.style.css";
import jsonParser from "../helper/jsonParser";
import { getConstantStringByLanguage } from "../helper/getConstantStringByLanguage";
import AudioIcon, { useAutoPlayAudio, handleClickAudio } from "../content/Assets/AudioIcon";

function VerticalMultipleResponse({
  sections,
  data,
  order,
  question,
  explanation,
  backgroundImage,
  section,
  slide,
  submitLesson,
  nextSection,
  playingAudioRef,
}) {
  const dispatch = useDispatch();
  var questionTexts =
    question.texts !== null &&
    question.texts !== undefined &&
    question.texts?.length > 0
      ? question.texts.map((text, index) => jsonParser(text, index))
      : question.texts;
  var questionChoices = question.choices;
  var questionSolutions = question.solutions;

  // const questionAudioLink = question?.audioLink;
  // const questionAudioRef = useRef(new Audio(ConstantStrings.IMAGE_URL + questionAudioLink));
  // const [isQuestionAudioPlaying, setIsQuestionAudioPlaying] = useState(false);
  
  // useAutoPlayAudio({
  //   content: question,
  //   audioRef: questionAudioRef,
  //   playingAudioRef,
  //   setIsAudioPlaying: setIsQuestionAudioPlaying,
  //   slideId: data._id,
  //   type: 1
  // });

  const explanationAudioLink = explanation?.audioLink;
  const explanationAudioRef = useRef(new Audio(ConstantStrings.IMAGE_URL + explanationAudioLink));
  const [isExplanationAudioPlaying, setIsExplanationAudioPlaying] = useState(false);

  //check if explanation is null
  if (explanation !== null && explanation) {
    if (
      explanation.texts !== null &&
      explanation.texts !== undefined &&
      explanation.texts?.length > 0 &&
      explanation.texts.some((item) => item?.length > 0)
    ) {
      var explanationTexts = explanation.texts.map((text, index) =>
        jsonParser(text, index)
      );
    }
    if (
      explanation.images !== null &&
      explanation.images !== undefined &&
      explanation.images?.length > 0 &&
      explanation.images.some((item) => item?.length > 0)
    ) {
      var explanationImages = explanation.images;
    }
  }

  //create a state variable to store the selected answers
  var [selected, setSelected] = useState(() => {
    if (sections[section].slides[slide].state) {
      return sections[section].slides[slide].state.selected;
    } else {
      return [];
    }
  });
  //create a state variable to store the checking state
  var [checkingState, setCheckingState] = useState(() => {
    if (sections[section].slides[slide].state) {
      return sections[section].slides[slide].state.checkingState;
    } else {
      return false;
    }
  });
  //create a state variable to store the explanation state
  var [explanationState, setExplanationState] = useState(() => {
    if (sections[section].slides[slide].state) {
      return sections[section].slides[slide].state.explanationState;
    } else {
      return false;
    }
  });

  useAutoPlayAudio({
    content: explanation,
    audioRef: explanationAudioRef,
    playingAudioRef,
    setIsAudioPlaying: setIsExplanationAudioPlaying,
    slideId: data._id,
    explanationState,
    type: 2
  });

  const [allCorrect, setAllCorrect] = useState(() => {
    if (sections[section].slides[slide].state) {
      return sections[section].slides[slide].state.allCorrect;
    } else {
      return false;
    }
  });
  var maxLength = 0;
  for (var i = 0; i < questionChoices.length; i++) {
    if (questionChoices[i].length > maxLength) {
      maxLength = questionChoices[i].length;
    }
  }
  const [widthButton, setWidthButton] = useState(maxLength >= 11 ? 20 : 10);
  const [maxWidth, setMaxWidth] = useState(60);

  var backgroundStyle = {
    borderRadius: "1rem 0 0 1rem",
    height: `35rem`,
    width: "50%",
  };
  var backgroundLeftStyle = {};
  if (
    backgroundImage[0] !== null &&
    backgroundImage[0] &&
    checkImage(backgroundImage[0])
  ) {
    backgroundLeftStyle = {
      ...backgroundStyle,
      width: "100%",
      // backgroundImage: `url(${memoizedImageData[1][0]})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "cover",
    };
  } else {
    backgroundLeftStyle = {
      ...backgroundStyle,
      width: "100%",
    };
  }
  if (
    backgroundImage[1] !== null &&
    backgroundImage[1] &&
    checkImage(backgroundImage[1])
  ) {
    backgroundStyle = {
      ...backgroundStyle,
      borderRadius: "0 1rem 1rem 0",
      // backgroundImage: `url(${memoizedImageData[1][1]})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "cover",
    };
  } else {
    backgroundStyle = {
      ...backgroundStyle,
      borderRadius: "0 1rem 1rem 0",
    };
  }
  let buttonStyle = {};
  if (maxLength <= 10) {
    buttonStyle = {
      width: "10rem",
      padding: "0.75rem 1rem",
      height: "3rem",
      opacity: 1,
      fontWeight: "bold",
      fontSize: "1.125rem",
    };
  } else {
    buttonStyle = {
      padding: "0.75rem 1.25rem",
      width: `20rem`,
      height: "auto",
      fontWeight: "bold",
      whiteSpace: "pre-wrap",
      outline: "0.0625rem solid",
      opacity: 1,
      fontSize: "1.125rem",
    };
  }

  var selectedStyle = {
    ...buttonStyle,
    backgroundColor: "#E6E1F5",
    outline: "0.125rem solid #572CD1",
  };

  var iconStyle = {
    zIndex: 100,
    position: "absolute",
    top: "0.7rem",
    width: "1.5rem",
    height: "1.5rem",
    left: "-0.7rem",
  };

  //McqButton component
  var maxWidthButton = 0;
  const divRef = useRef(null);
  const McqButton = ({ id, index, children }) => {
    const buttonRef = useRef(null);
    useEffect(() => {
      if (buttonRef.current.clientWidth > maxWidthButton) {
        maxWidthButton = buttonRef.current.clientWidth;
      }
      if (widthButton < maxWidthButton / ConstantStrings.BASE_REM) {
        setWidthButton(maxWidthButton / ConstantStrings.BASE_REM);
        buttonRef.current.style.width = `${
          maxWidthButton / ConstantStrings.BASE_REM
        }rem`;
      } else {
        buttonRef.current.style.width = `${widthButton}rem`;
      }
      //set all auto-height buttons to the same height
    }, [id]);
    return (
      //if index in selected, set the style to selectedStyle
      //if index in selected and checkingState = true, set the style to correctStyle if the answer is correct, set the style to incorrectStyle if the answer is incorrect
      <div className="is-relative">
        {/* <button id={id} ref={buttonRef} className="button" style={index === selected ? (checkingState ? (questionSolutions[selected] === true ? correctStyle : incorrectStyle) : selectedStyle) : buttonStyle} onClick={() => handleSelect(index)} disabled={checkingState}>
                    {children}
                </button> */}
        {selected.includes(index) && checkingState ? (
          questionSolutions[index] === true && allCorrect ? (
            <img src="/images/common/greenV.svg" style={iconStyle} alt="loading" />
          ) : (
            <img src="/images/common/redX.svg" style={iconStyle} alt="loading" />
          )
        ) : (
          <div
            className="icon"
            style={{
              ...iconStyle,
              width: "0.75rem",
              height: "0.75rem",
            }}
          ></div>
        )}
        <button
          id={id}
          ref={buttonRef}
          className={`${
            selected.includes(index)
              ? checkingState && allCorrect
                ? questionSolutions[index] === true
                  ? "has-background-kurio-green-light-3 is-kurio-green-main-accent has-text-kurio-green-main-accent"
                  : "has-background-kurio-red-light-3 is-kurio-red-main-accent has-text-kurio-red-main-accent"
                : "has-background-kurio-purple-light-3 is-kurio-purple-main-accent has-text-kurio-purple-main-accent"
              : "has-background-kurio-main-color-white has-text-kurio-main-color-black is-kurio-main-color-black"
          } button is-shadowless has-text-weight-bold is-outlined`}
          style={
            selected.includes(index) && !checkingState
              ? selectedStyle
              : buttonStyle
          }
          onClick={() => handleSelect(index)}
          disabled={checkingState}
        >
          {jsonParser(children)}
        </button>
      </div>
    );
  };

  //mapping each choice to a component
  const MapChoices = questionChoices.map((choice, index) => {
    return (
      //id = "auto-height" if the choice is longer than 32 characters
      <div
        className="column is-narrow is-centered"
        style={{ padding: "0.5rem 0.75rem" }}
        key={index}
      >
        <McqButton
          id={choice.length > 10 && !checkImage(choice) ? "auto-height" : ""}
          index={index}
        >
          {choice}
        </McqButton>
      </div>
    );
  });

  //create a function to handle the selection of an answer
  //when an answer is selected, add the index of the answer to the selected state variable
  const handleSelect = (index) => {
    if (selected.includes(index)) {
      setSelected(selected.filter((item) => item !== index));
    } else {
      setSelected([...selected, index]);
    }
  };

  //create a function to handle the checking of the answer
  //when the answer is checked, set the checking state variable to true
  //if all selected answers correct, alert "Correct!", change the background color of the selected answer to green
  //if not all selected answer correct, alert "Incorrect!", change the background color of the selected answer to red
  const handleCheck = () => {
    var correctFlag = true;
    var countCorrectANswer = 0;
    if (selected.length > 0) {
      setCheckingState(true);
      for (var i = 0; i < selected.length; i++) {
        if (questionSolutions[selected[i]] !== true) {
          correctFlag = false;
        }
      }
      for (let i = 0; i < questionSolutions.length; i++) {
        if (questionSolutions[i] === true) {
          countCorrectANswer++;
        }
      }
      if (selected.length !== countCorrectANswer) {
        correctFlag = false;
      }
    } else {
      // alert("Please select an answer!");
    }

    if (correctFlag) {
      // alert("Correct!");
      setAllCorrect(true);
    } else {
      // alert("Incorrect!");
    }
  };

  //create a function to handle the reset of the question
  //when the question is reset, set the selected state variable to -1
  //set the checking state variable to false
  const handleReset = () => {
    setSelected([]);
    setCheckingState(false);
    setAllCorrect(false);
  };

  //create a function to handle the showing of the explanation
  const handleShowExplanation = () => {
    setExplanationState(true);
  };

  const showNextSlide = () => {
    dispatch(
      setQuestionState({
        section: section,
        index: slide,
        state: {
          selected: selected,
          checkingState: checkingState,
          explanationState: explanationState,
          allCorrect: allCorrect,
        },
      })
    );
    submitLesson(section, slide);
    if (sections[section].slides[slide].isLast) {
      nextSection();
    } else {
      dispatch(setQuestionVisible({ section: section, index: slide + 1 }));
    }
  };

  useEffect(() => {
    if (divRef.current.clientWidth / ConstantStrings.BASE_REM !== maxWidth) {
      setMaxWidth(divRef.current.clientWidth / ConstantStrings.BASE_REM);
    }
    const setWidth = () => {
      setMaxWidth(divRef.current.clientWidth / ConstantStrings.BASE_REM);
    };
    window.addEventListener("resize", setWidth);
    return () => window.removeEventListener("resize", setWidth);
  }, [maxWidth]);
  return (
    <div style={{ height: `35rem` }} className="is-flex is-flex-direction-row">
      <ScrollRef />
      <div style={{ width: "50%" }} ref={divRef}>
        <BackgroundImageFromUrl
          objectId={backgroundImage[0]}
          style={backgroundLeftStyle}
          className={`${
            !checkImage(backgroundImage[0])
              ? "has-background-kurio-main-color-light-gray"
              : ""
          }`}
        ></BackgroundImageFromUrl>
      </div>
      <BackgroundImageFromUrl
        objectId={backgroundImage[1]}
        style={{
          ...backgroundStyle,
          width: "50%",
          padding: "2rem",
          position: "relative",
        }}
        className={`${
          !checkImage(backgroundImage[1])
            ? "has-background-kurio-main-color-light-gray"
            : ""
        }  is-flex is-flex-direction-column is-justify-content-space-between has-text-left`}
      >
        {!explanationState && (
          <div className="question-container">
            <div>
              {data?.template.question !== null &&
                data?.template.question &&
                data?.template.question.length > 0 && (
                  <div className="mb-4">
                    <QuestionNumberTag
                      number={order === 0 ? data?.order : order}
                    />
                  </div>
                )}
            </div>
            {
              //render questionTexts if its array has length greater than 0
              questionTexts !== null &&
                questionTexts !== undefined &&
                questionTexts?.length > 0 && (
                  <div className=" has-text-kurio-main-color-black mb-4">
                    {/* {questionAudioLink && <AudioIcon isPlaying={isQuestionAudioPlaying} onClick={() => handleClickAudio(questionAudioRef, setIsQuestionAudioPlaying)} />} */}
                    {questionTexts}
                  </div>
                )
            }
            {questionChoices.length === 4 &&
            (widthButton + 1.5) * 2 + 4 < maxWidth ? (
              <div>
                <div className="columns  p-0 m-0">
                  {MapChoices[0]}
                  {MapChoices[1]}
                </div>
                <div className="columns  p-0 m-0">
                  {MapChoices[2]}
                  {MapChoices[3]}
                </div>
              </div>
            ) : // if questionChoices has length 5, render the choices in a 3x2 grid
            questionChoices.length === 5 ? (
              <>
                {(widthButton + 1.5) * 2 + 4 > maxWidth ? (
                  <div className="columns is-multiline  p-0 m-0">
                    {MapChoices}
                  </div>
                ) : (
                  <div>
                    <div className="columns p-0 m-0">
                      {MapChoices[0]}
                      {MapChoices[1]}
                    </div>
                    <div className="columns p-0 m-0">
                      {MapChoices[2]}
                      {MapChoices[3]}
                    </div>
                    <div className="columns p-0 m-0">{MapChoices[4]}</div>
                  </div>
                )}
              </>
            ) : // if questionChoices has length 6, render the choices in a 3x3 grid
            questionChoices.length === 6 ? (
              <>
                {(widthButton + 1.5) * 3 + 4 > maxWidth ? (
                  <div>
                    <div className="columns  p-0 m-0">
                      {MapChoices[0]}
                      {MapChoices[1]}
                    </div>
                    <div className="columns  p-0 m-0">
                      {MapChoices[2]}
                      {MapChoices[3]}
                    </div>
                    <div className="columns  p-0 m-0">
                      {MapChoices[4]}
                      {MapChoices[5]}
                    </div>
                  </div>
                ) : (
                  <div>
                    <div className="columns  p-0 m-0">
                      {MapChoices[0]}
                      {MapChoices[1]}
                      {MapChoices[2]}
                    </div>
                    <div className="columns  p-0 m-0">
                      {MapChoices[3]}
                      {MapChoices[4]}
                      {MapChoices[5]}
                    </div>
                  </div>
                )}
              </>
            ) : questionChoices.length === 3 ? (
              <>
                {(widthButton + 1.5) * 3 + 4 > maxWidth ? (
                  <div className="columns is-multiline  p-0 m-0">
                    {MapChoices}
                  </div>
                ) : (
                  <div>
                    <div className="columns  p-0 m-0">
                      {MapChoices[0]}
                      {MapChoices[1]}
                    </div>
                    <div className="columns  p-0 m-0">{MapChoices[2]}</div>
                  </div>
                )}
              </>
            ) : (
              <div className="columns is-multiline  p-0 m-0">{MapChoices}</div>
            )}

            {checkingState && allCorrect && (
              <div>
                <TagCheckMultipleResponse check={true} />
              </div>
            )}
            {checkingState && !allCorrect && (
              <div>
                <TagCheckMultipleResponse check={false} />
              </div>
            )}
          </div>
        )}

        {/* only appears when explanationState is true */}
        {explanationState && (
          <div className="explanation-container is-flex is-flex-direction-column">
            <div>
              {data?.template.question !== null &&
                data?.template.question &&
                data?.template.question.length > 0 && (
                  <div className="mb-4">
                    <QuestionNumberTag
                      number={order === 0 ? data?.order : order}
                    />
                  </div>
                )}
            </div>

            <div
              className="main-content-multiple-vertical has-text-kurio-main-color-black is-flex is-flex-direction-column"
              style={{
                overflow: "hidden",
                overflowY: "scroll",
                height: "16.5rem",
                gap: "1rem",
              }}
            >
              {explanationAudioLink && playingAudioRef && <AudioIcon isPlaying={isExplanationAudioPlaying} onClick={() => handleClickAudio(explanationAudioRef, setIsExplanationAudioPlaying)} />}
              {((explanationTexts !== null &&
                explanationTexts !== undefined &&
                explanationTexts?.length > 0) ||
                (explanationImages !== null &&
                  explanationImages !== undefined &&
                  explanationImages?.length > 0)) &&
                explanation.texts?.length >= explanation.images?.length && (
                  <>
                    {explanation.texts.map((item, index) => (
                      <div
                        key={index}
                        className="is-flex is-flex-direction-column is-align-items-center"
                        style={{ gap: "1.5rem" }}
                      >
                        {explanationTexts !== null &&
                          explanationTexts !== undefined &&
                          item?.length > 0 && (
                            <div key={item}>{explanationTexts[index]}</div>
                          )}
                        {/* only appears when explanationImages has length greater than 0 */}
                        {explanationImages !== null &&
                          explanationImages !== undefined &&
                          explanationImages[index]?.length > 0 && (
                            <ImageFromUrl objectId={explanationImages[index]} />
                          )}
                      </div>
                    ))}
                  </>
                )}
              {((explanationTexts !== null &&
                explanationTexts !== undefined &&
                explanationTexts?.length > 0) ||
                (explanationImages !== null &&
                  explanationImages !== undefined &&
                  explanationImages?.length > 0)) &&
                explanation.texts?.length < explanation.images?.length && (
                  <>
                    {explanationImages.map((item, index) => (
                      <div
                        key={item}
                        className="is-flex is-flex-direction-column is-align-items-center"
                        style={{ gap: "1.5rem" }}
                      >
                        {explanationTexts !== null &&
                          explanationTexts !== undefined &&
                          explanation.texts[index]?.length > 0 && (
                            <div key={index}>{explanationTexts[index]}</div>
                          )}
                        {/* only appears when explanationImages has length greater than 0 */}
                        {explanationImages !== null &&
                          explanationImages !== undefined &&
                          item?.length > 0 && (
                            <ImageFromUrl objectId={explanationImages[index]} />
                          )}
                      </div>
                    ))}
                  </>
                )}
            </div>
          </div>
        )}

        <div
          className={`content is-flex is-flex-direction-row ${
            (checkingState && !allCorrect) || !checkingState
              ? "is-align-items-flex-end is-justify-content-space-between"
              : "is-align-items-flex-end"
          }`}
          style={{
            height: "9rem",
          }}
        >
          {/* only appears when checkingState is false */}
          {!checkingState && !allCorrect && (
            <PrimaryButtonQuestion
              disabled={!(selected.length > 0)}
              className="button"
              onClick={handleCheck}
            >
              {getConstantStringByLanguage(ConstantStrings.SUBMIT)}
            </PrimaryButtonQuestion>
          )}
          {/* only appears when checkingState is true and any selected answer is incorrect */}
          {checkingState && !allCorrect && (
            <PrimaryButtonQuestion className="button" onClick={handleReset}>
              {getConstantStringByLanguage(ConstantStrings.TRY_AGAIN)}
            </PrimaryButtonQuestion>
          )}
          {/* Next and "Xem giai thich" button appears when checkingState is true and all selected answers is correct */}
          <div
            className="is-flex is-flex-direction-column"
            style={{ gap: "1rem", marginTop: "2rem" }}
          >
            {checkingState &&
              allCorrect &&
              selected.every((item) => questionSolutions[item] === true) &&
              explanationState === false && (
                <>
                  {explanation !== null &&
                    explanation !== undefined &&
                    ((explanationImages !== null &&
                      explanationImages?.length > 0) ||
                      (explanationTexts !== null &&
                        explanationTexts?.length > 0)) && (
                      <SecondaryButtonQuestion
                        className="button"
                        defaultColor={"is-kurio-purple-light-2"}
                        onClick={handleShowExplanation}
                      >
                        {getConstantStringByLanguage(ConstantStrings.SHOW_EXPLANATION)}
                      </SecondaryButtonQuestion>
                    )}
                </>
              )}
            {/* "Xem cau hoi" button appears when explanationState is true */}
            {explanationState && (
              <SecondaryButtonQuestion
                className="button"
                defaultColor={"is-kurio-purple-light-2"}
                onClick={() => {
                  setExplanationState(false);
                }}
              >
                {getConstantStringByLanguage(ConstantStrings.SHOW_QUESTION)}
              </SecondaryButtonQuestion>
            )}
            {checkingState &&
              allCorrect &&
              selected.every((item) => questionSolutions[item] === true) && (
                <div
                  className={`${
                    (
                      slide + 1 > sections[section].slides.length - 1
                        ? sections[section].isFinished
                        : sections[section].slides[slide + 1].visible
                    )
                      ? "is-hidden"
                      : ""
                  }`}
                >
                  <PrimaryButtonQuestion onClick={showNextSlide}>
                    {getConstantStringByLanguage(ConstantStrings.NEXT)}
                  </PrimaryButtonQuestion>
                </div>
              )}
          </div>

          {(selected.some((item) => questionSolutions[item] !== true) ||
            (!checkingState && !allCorrect)) && (
            <div
              className={`${
                (
                  slide + 1 > sections[section].slides.length - 1
                    ? sections[section].isFinished
                    : sections[section].slides[slide + 1].visible
                )
                  ? "is-hidden"
                  : ""
              }`}
              style={{ float: "right" }}
            >
              <TertiaryButtonQuestion
                onClick={showNextSlide}
                suffix={"admin/frontend-images/button/button-skip-icon"}
              >
                {getConstantStringByLanguage(ConstantStrings.SKIP)}
              </TertiaryButtonQuestion>
            </div>
          )}
        </div>
      </BackgroundImageFromUrl>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    sections: state.questions.sections,
  };
}

export default connect(mapStateToProps)(VerticalMultipleResponse);
